// 专供客户端ajax请求使用
import axios from 'axios'
import app from '@/main'
import store from '@/store'
import errorTips from '@/assets/json/errorTips'
import { MessageBox } from 'element-ui'

axios.defaults.validateStatus = function(status) {
  return status >= 200 && status <= 204 // default
}
const ajax = (type, penetrate = false) => async (
  url,
  data = {},
  ext = { timeout: 30000 }
) => {
  const { ignoreMsg = false, showLoginMsgbox = false, noToken = false, loading = true, auth_version = '', credential = false } = ext
  const config = {}
  if (credential) {
    axios.defaults.withCredentials = true
  } else {
    axios.defaults.withCredentials = false
  }
  if (store.state.hasToken && !noToken) {
    try {
      const token = await app.$auth('get_access_token')
      config.headers = {
        Authorization: token,
        Authorization_Type: 3
      }
    } catch (error) {
      if (showLoginMsgbox) {
        showLoginMsgboxFunc()
      } else {
        app.$message.error('登录态失效，请重新登录')
        setTimeout(() => {
          store.commit('LOGOUT')
        }, 1000)
      }
    }
  }
  // 不用管登录态
  if (auth_version) {
    config.headers = {
      'Auth-Version': auth_version
    }
  }
  Object.assign(config, ext)
  config.url = /^https?/.test(url) ? url : CONFIG.api_edu + url
  // 因为open-service这个解密手机号的服务需要传Authorization-Type，故多此一举，不会影响别的请求。
  if (config.url.includes('open-service')) {
    const token = await app.$auth('get_access_token')
    config.headers = {
      Authorization: token,
      'Authorization-Type': '11'
    }
  }
  config.method = type
  if (['put', 'post', 'patch'].includes(type)) {
    config.data = data
  }
  if (type === 'get' || type === 'delete') {
    config.params = Object.assign({}, data)
    config.params.TIME = +new Date()
  }

  try {
    loadingSwitch(loading)
    const res = await axios(config)
    loadingSwitch(false)
    return penetrate ? res : res.data // 对API.[XXX]请求方式的兼容
  } catch (error) {
    loadingSwitch(false)
    const response = error.response
    let errorCode
    let errorMessage
    if (response) {
      const data = response.data
      errorCode = data.error_code || data.status || response.status
      errorMessage =
        data.error_message ||
        data.message ||
        errorTips[errorCode] ||
        `未定义错误号 ${errorCode} 的错误提示`
      if (errorCode === 100010 || errorCode === 401) {
        if (showLoginMsgbox) {
          showLoginMsgboxFunc()
        } else {
          store.commit('LOGOUT')
        }
      }
    } else {
      errorMessage = errorMessage = error.message.includes('timeout of')
        ? errorTips['REQUEST_TIMEOUT']
        : error.message.includes('Network Error')
          ? errorTips['REQUEST_ERROR']
          : error.message
      errorCode = error.status || 0
    }
    if (!ignoreMsg) app.$message.error(errorMessage)
    return errorCode < 400 && penetrate // 对API.[XXX]请求方式的兼容
      ? Promise.resolve(error)
      : Promise.reject({ error_code: errorCode, error_message: errorMessage, ...response })
  }
}

function showLoginMsgboxFunc() {
  MessageBox('你还没登录，请先登录', '提示', {
    center: true,
    confirmButtonText: '去登录',
    cancelButtonText: '取消'
  }).then(() => {
    window.location.href = `${window.CONFIG.school}/login?fromUrl=${window.location.href}`
  })
}

function loadingSwitch(loading) {
  // if (app) {
  //   if (loading) {
  //     app.$loading(loading)
  //   } else {
  //     app.$loading.close()
  //   }
  // }
}

// 建议按需使用不判断status < 400的API
export const head = axios.head
export const get = ajax('get')
export const post = ajax('post')
export const put = ajax('put')
export const patch = ajax('patch')
export const del = ajax('delete')

// 这是对原本判断status < 400的API的兼容
export default {
  get: ajax('get', true),
  post: ajax('post', true),
  patch: ajax('patch', true),
  put: ajax('put', true),
  delete: ajax('delete', true)
}
